import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

import type { TradeDoneProps as TradeDoneButtonProps } from './tradeDone.connect';
import { connectTradeDoneButton } from './tradeDone.connect';

export const TradeDoneButtonComponent: FC<TradeDoneButtonProps> = ({ onTradeDone, className }) => {
  return (
    <button type="button" className={classNames('btn btn-primary', className)} onClick={onTradeDone}>
      <FormattedMessage id="form.buttons.TradeDone" />
    </button>
  );
};

export const TradeDoneButton = connectTradeDoneButton(TradeDoneButtonComponent);

TradeDoneButtonComponent.displayName = 'TradeDoneButton';
